
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { IAggregateResultHypermediaRepresentation } from '../../shared/contracts/AggregateContract';
import { performance } from '../../shared/services/PerformanceService';
import store from '../../store/store';
import OverviewBase from './OverviewBase.vue';

@Component({})
export default class HivesOverview extends OverviewBase {
  async beforeRouteEnter(to: Route, from: Route, next: Function) {
    performance.track('Hives Dashboard');
    await store.dispatch('aggregate/fetchHivesAggregate');
    next();
  }

  protected get aggregate(): IAggregateResultHypermediaRepresentation {
    return this.aggregateState.hivesAggregate;
  }

  protected get title(): string {
    return 'Hives Dashboard';
  }

  protected get placeholder(): string {
    return 'Search on hive';
  }

  public goToDetails(id: string, name: string) {
    this.$router.push({name: 'hiveOverview', params: {id}, query: {name}});
  }
}
